import { get } from '@core/api/baseApi';
import { GetSolicitationsResponse } from '@core/types';

export const getSolicitations = (studyInstanceUid: string): Promise<GetSolicitationsResponse> => get(`/studies/${studyInstanceUid}/solicitation`);
